/** The conversation sidebar configuration. */
export const conversationSidebarConfig = {
    contact: {
        name: 'Contact',
        icon: 'user',
    },
    attachments: {
        name: 'Attachments',
        icon: 'paperclip',
    },
    sideConversations: {
        name: 'Side conversations',
        icon: 'arrow-square-right',
    },
    internalNotes: {
        name: 'Internal notes',
        icon: 'sticky-note',
    },
    customFields: {
        name: 'Custom fields',
        icon: 'input',
    },
    activityLog: {
        name: 'Activity log',
        icon: 'activity',
    },
    integrations: {
        name: 'Integrations',
        icon: 'code',
    },
};
/** The conversation sidebar items. */
export const conversationSidebarItems = Object.keys(conversationSidebarConfig);
